import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => navigate("/dashboard", { state: { user: res.data.user }, replace: true }))
      .catch(() => navigate("/login", { replace: true }));
  }, [location, navigate]);

  return (
    <div data-testid="auth-callback-loading" className="min-h-screen bg-[#FBF7EE] flex items-center justify-center">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#A67C1E]">Memproses login...</p>
    </div>
  );
}
